// Copyright (c) 2016 Deere & Company

import '../../../../shared/components/labeled-string/index.scss';
import KeyValuePair, {getDefaultState} from '@deere/cps-it.warranty-model-factory/lib/key-value-pair';
import React, {PropTypes} from 'react';
import TranslatedOption from '../../../../shared/components/translated-option';
import dropdownPlaceholders from '../../utils/dropdown-placeholders';

function handleItemChange(event) {

    const itemToSend = dropdownPlaceholders.includes(event.target.value) ? getDefaultState() : this.data.find(item => item.key === event.target.value);

    this.onItemChange(this.name, itemToSend);

}

const Dropdown = ({data, disabled, name, onItemChange, text, value}) => {

    const handleChangeObject = {
        data,
        name,
        onItemChange,
        text
    };

    return (
        <select
            className='labeled-string'
            disabled={disabled}
            onChange={handleChangeObject::handleItemChange}
        >
            <TranslatedOption
                text={text}
                value={value}
            />
            {data.map(item =>
                <option
                    key={item.key}
                    value={item.key}
                >
                    {item.value}
                </option>)}
        </select>
    );

};

Dropdown.displayName = 'Dropdown';
Dropdown.propTypes = {
    data: PropTypes.arrayOf(PropTypes.instanceOf(KeyValuePair)).isRequired,
    disabled: PropTypes.bool,
    name: PropTypes.string.isRequired,
    onItemChange: PropTypes.func.isRequired,
    text: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired
};
Dropdown.defaultProps = {
    disabled: false
};

export default Dropdown;



// WEBPACK FOOTER //
// ./src/product/status-change-request/components/dropdowns/dropdown.js